import type {
    Exemplar,
    LabeledIdentified
} from 'typings/portaro.be.types';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';
import type ExemplarService from '../exemplar.service';
import type LoanRequestService from '../../loan/loan-request.service';
import type {AnyObject} from 'typings/portaro.fe.types';
import type {MoreShowableViewableExemplar} from './types';

export class KpExemplarsListPresenter {
    public static presenterName = 'kpExemplarsListPresenter';

    /*@ngInject*/
    constructor(private finishedResponseInteractionService: FinishedResponseInteractionService,
                private exemplarService: ExemplarService,
                private loanRequestService: LoanRequestService) {
    }

    public discardExemplar(exemplar: Exemplar): Promise<void> {
        return this.exemplarService.discardExemplar(exemplar);
    }

    public editExemplar(exemplar: Exemplar): Promise<void> {
        return this.exemplarService.editExemplar(exemplar);
    }

    public deleteExemplar(exemplar: Exemplar): Promise<void> {
        return this.exemplarService.deleteExemplar(exemplar);
    }

    public restoreExemplar(exemplar: Exemplar): Promise<void> {
        return this.exemplarService.restoreExemplar(exemplar);
    }

    public async requestExemplar(exemplar: Exemplar): Promise<void> {
        try {
            const actionResponse = await this.loanRequestService.requestExemplar(exemplar);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
        }
    }

    public showMore(exemplar: MoreShowableViewableExemplar): void {
        exemplar.showMore = !exemplar.showMore;
    }

    public filterProperties(properties: LabeledIdentified<string>[], exemplars: Exemplar[]): LabeledIdentified<string>[] {
        return properties.filter((property) => {
            const exemplarListOnProperty = exemplars.map((exemplar) => exemplar[property.id]);
            return !this.isArrayFullOfNull(exemplarListOnProperty);
        })
    }

    private isArrayFullOfNull(objects: AnyObject[]): boolean {
        return objects.every((element) => element === null)
    }
}